import Vue from 'vue'
import {viewHistoryAdd, addLog} from '@/api/user'

// 浏览记录
Vue.prototype.$addHistory = function (params) {
  viewHistoryAdd(params).then(res=>{
    if(res.code == 0){}
  })
}

// 埋点
Vue.prototype.$addLog = function (params) {
  return new Promise((resolve, reject) => {
    addLog(params).then(res=>{
      resolve(res)
    }).catch(err=>{
      reject(err)
    })
  })
}